import type { JobIdStorageInterface } from '../job_service/job_service';

export class JobIdStorageMemory implements JobIdStorageInterface {
  #items = new Map<string, string>();

  async get(stateId: string): Promise<string | undefined> {
    return this.#items.get(stateId);
  }

  async getAll(): Promise<string[]> {
    return [...this.#items.values()];
  }

  async set(stateId: string, jobId: string): Promise<void> {
    this.#items.set(stateId, jobId);
  }

  async delete(stateId: string): Promise<void> {
    this.#items.delete(stateId);
  }
}
